@if (copyBtnConfig) {<tpa-button [config]="copyBtnConfig"></tpa-button>}